module.exports = __webpack_public_path__ + "img/img10.9b56dc70.jpg";